<div class="global-search-container">
  <div class="search-input-wrapper">
    <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2" />
      <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>

    <input #searchInput type="text" class="search-input" [value]="searchText" (input)="onSearchInput($event)"
      (focus)="onFocus()" placeholder="Search" autocomplete="off" maxlength="200" />

    <button *ngIf="searchText && searchText.length > 0" class="clear-button" (click)="clearSearch()" type="button">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div *ngIf="isOpen" class="search-results-dropdown">
    <div *ngIf="!searchText || searchText.length < 2" class="recent-searches-section">
      <div class="recent-searches-header">
        <div class="recent-title">Recent Searches</div>
        <button *ngIf="recentSearches.length > 0" class="clear-recent-btn" (click)="clearRecentSearches()">
          Clear All
        </button>
      </div>

      <div *ngIf="recentSearches.length > 0" class="recent-searches-list">
        <div *ngFor="let search of recentSearches" class="recent-search-item" (click)="selectRecentSearch(search)">
          <svg class="recent-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" />
          </svg>
          <span class="recent-search-text">{{search}}</span>
          <button class="remove-recent-btn" (click)="removeRecentSearch(search); $event.stopPropagation()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <div *ngIf="recentSearches.length === 0" class="no-recent-searches">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="#a0a0a0" stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
        <p class="no-recent-title">No recent searches</p>
        <p class="no-recent-subtitle">Your recent searches will appear here</p>
      </div>
    </div>

    <div *ngIf="searchText && searchText.length >= 2">
      <div *ngIf="isSearching || (!hasResults() &&  (totalApis !== completedApis))" class="search-state-loading">
        <div class="loading-spinner"></div>
        <span class="loading-text">Searching...</span>
      </div>

      <!-- <div *ngIf="!isSearching && noResults" class="no-results"> -->
      <div *ngIf="!isSearching && !hasResults() &&  (totalApis == completedApis) " class="no-results">
        <div class="no-results-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#a0a0a0" stroke-width="1.5" />
            <path d="M8 8l8 8M16 8l-8 8" stroke="#a0a0a0" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </div>
        <p class="no-results-title">No results found</p>
        <p class="no-results-subtitle">Try different search terms</p>
      </div>

      <div *ngIf="!isSearching && hasResults()" class="results-container">
        <div class="results-grid">
          <!-- Users Section -->
          <div *ngIf="groupedResults?.users?.length > 0" class="result-card">
            <div class="card-header" (click)="toggleSection('users')">
              <div class="card-header-left">
                <div class="card-icon-wrapper users-icon">
                  <svg class="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                  </svg>
                </div>
                <div class="card-title">
                  <span class="card-name">Users</span>
                  <!-- <span class="card-count">{{groupedResults?.users?.length}}</span> -->
                </div>
              </div>
              <svg class="chevron-icon" [class.expanded]="expandedSections['users']" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div *ngIf="expandedSections['users']" class="card-content">
              <div class="result-list">
                <div *ngFor="let result of groupedResults?.users" class="result-list-item"
                  (click)="selectResult(result)">
                  <div class="result-avatar">
                    <div class="avatar-placeholder">{{getInitials(result.title)}}</div>
                  </div>
                  <div class="result-details">
                    <div class="result-main">
                      <div class="result-title-row">
                        <div class="result-title" [innerHTML]="highlightSearchTerm(result.title)"></div>
                        <div class="result-role">{{getUserRole(result.data)}}</div>
                      </div>
                      <div class="result-subtitle" [innerHTML]="highlightSearchTerm(result.data?.email)"></div>
                    </div>
                    <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CSQ Team Section -->
          <div *ngIf="groupedResults?.csq_team?.length > 0" class="result-card">
            <div class="card-header" (click)="toggleSection('csq_team')">
              <div class="card-header-left">
                <div class="card-icon-wrapper csq-icon">
                  <svg class="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="card-title">
                  <span class="card-name">CSQ Team</span>
                  <!-- <span class="card-count">{{groupedResults?.csq_team?.length}}</span> -->
                </div>
              </div>
              <svg class="chevron-icon" [class.expanded]="expandedSections['csq_team']" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div *ngIf="expandedSections['csq_team']" class="card-content">
              <div class="result-list">
                <div *ngFor="let result of groupedResults?.csq_team" class="result-list-item"
                  (click)="selectResult(result)">
                  <div class="result-avatar">
                    <div class="avatar-placeholder csq-avatar">{{getInitials(result.title)}}</div>
                  </div>
                  <div class="result-details">
                    <div class="result-main">
                      <div class="result-title-row">
                        <div class="result-title" [innerHTML]="highlightSearchTerm(result.title)"></div>
                        <div class="result-role">CSQ Team Member</div>
                      </div>
                      <div *ngIf="result.data?.email" class="result-subtitle"
                        [innerHTML]="highlightSearchTerm(result.data.email)"></div>
                      <div *ngIf="!result.data?.email" class="result-subtitle">CSQ Team</div>
                    </div>
                    <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Schools Section -->
          <div *ngIf="groupedResults?.schools?.length > 0" class="result-card">
            <div class="card-header" (click)="toggleSection('schools')">
              <div class="card-header-left">
                <div class="card-icon-wrapper schools-icon">
                  <svg class="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="card-title">
                  <span class="card-name">Schools</span>
                  <!-- <span class="card-count">{{groupedResults?.schools?.length}}</span> -->
                </div>
              </div>
              <svg class="chevron-icon" [class.expanded]="expandedSections['schools']" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div *ngIf="expandedSections['schools']" class="card-content">
              <div class="result-list">
                <div *ngFor="let result of groupedResults?.schools" class="result-list-item"
                  (click)="selectResult(result)">
                  <div class="result-avatar">
                    <div class="avatar-placeholder school-avatar">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor"
                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                  <div class="result-details">
                    <div class="result-main">
                      <div class="result-title-row">
                        <div class="result-title" [innerHTML]="highlightSearchTerm(result.title)"></div>
                        <div class="result-role">School</div>
                      </div>
                      <div class="result-subtitle" [innerHTML]="getSchoolLocation(result.data)"></div>
                    </div>
                    <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Students Section -->
          <div *ngIf="groupedResults?.student?.length > 0" class="result-card">
            <div class="card-header" (click)="toggleSection('student')">
              <div class="card-header-left">
                <div class="card-icon-wrapper student-icon">
                  <svg class="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                    <path d="M20 8v6M23 11h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                </div>
                <div class="card-title">
                  <span class="card-name">Students</span>
                  <!-- <span class="card-count">{{groupedResults?.student?.length}}</span> -->
                </div>
              </div>
              <svg class="chevron-icon" [class.expanded]="expandedSections['student']" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div *ngIf="expandedSections['student']" class="card-content">
              <div class="result-list">
                <div *ngFor="let result of groupedResults?.student" class="result-list-item"
                  (click)="selectResult(result)">
                  <div class="result-avatar">
                    <div class="avatar-placeholder student-avatar">{{getInitials(result.title)}}</div>
                  </div>
                  <div class="result-details">
                    <div class="result-main">
                      <div class="result-title-row">
                        <div class="result-title" [innerHTML]="highlightSearchTerm(result.title)"></div>
                        <div class="result-role">{{getStudentGrade(result.data)}}</div>
                      </div>
                      <div class="result-subtitle" [innerHTML]="getStudentSchool(result.data)"></div>
                    </div>
                    <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Events Section -->
          <div *ngIf="groupedResults?.events?.length > 0" class="result-card">
            <div class="card-header" (click)="toggleSection('events')">
              <div class="card-header-left">
                <div class="card-icon-wrapper events-icon">
                  <svg class="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2" />
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" />
                  </svg>
                </div>
                <div class="card-title">
                  <span class="card-name">Events</span>
                  <!-- <span class="card-count">{{groupedResults?.events?.length}}</span> -->
                </div>
              </div>
              <svg class="chevron-icon" [class.expanded]="expandedSections['events']" width="20" height="20"
                viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div *ngIf="expandedSections['events']" class="card-content">
              <div class="result-list">
                <div *ngFor="let result of groupedResults?.events" class="result-list-item"
                  (click)="selectResult(result)">
                  <div class="result-avatar">
                    <div class="avatar-placeholder event-avatar">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor"
                          stroke-width="1.5" />
                        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="1.5" />
                      </svg>
                    </div>
                  </div>
                  <div class="result-details">
                    <div class="result-main">
                      <div class="result-title-row">
                        <div class="result-title" [innerHTML]="highlightSearchTerm(result.title)"></div>
                        <div class="result-role">Event</div>
                      </div>
                      <div class="result-subtitle" [innerHTML]="getEventDetails(result.data)"></div>
                    </div>
                    <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>